import { Component, OnInit } from '@angular/core';
import { SpinnerService } from "./spinner.service";

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})

export class SpinnerComponent implements OnInit {

  constructor(
      public spinner: SpinnerService,
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/modules/spinner/spinner.component.ts